// extracted by mini-css-extract-plugin
module.exports = {"tag":"category-tag_tag__1D7Vh","tagUrl":"category-tag_tagUrl__3IImh","normal":"category-tag_normal__15iG5","large":"category-tag_large__16ZA7"};